import { useEffect } from 'react';
import { counterTrigger } from 'Src/tools/counters';
/**
 * Хук для тригера счетчиков с элементов, которые имеют аттрибут name, начинающийся с 'clb'\
 * Использовать только в компонентах, которые рендерятся внутри аппки Pets и только в случаях, когда нет возможности    обработать клик и вызвать counterTrigger.
 * Во всех остальных случаях использовать нужно counterTrigger.
 * @returns void
 */
const useLegacyCounterTrigger = () => {
    const handleDocumentClick = (e: MouseEvent) => {
        const target = e.target as HTMLElement;
        const targetClosest = target.closest('a') || target.closest('button');
        if (targetClosest) {
            const name = targetClosest.getAttribute('name');
            if (name && name.startsWith('clb')) {
                const counter = name.replace('clb', '');
                counterTrigger('blockClick', {
                    rbmail: {
                        id: counter,
                    },
                });
            }
        }
    };
    useEffect(() => {
        document.addEventListener('click', handleDocumentClick);
        return () => {
            document.removeEventListener('click', handleDocumentClick);
        };
    }, []);
};
export default useLegacyCounterTrigger;
